import { t } from '@muraletta/i18n';
import { languageForCountry } from '@muraletta/language-policy';
// IP-based editorial localization. Never changes currency, checkout eligibility or shipping.
const COUNTRY_CITIES = {
  FR: ['France', 'Paris', 'Annecy', 'Marseille', 'Lyon', 'Bordeaux', 'Nice'],
  DE: ['Allemagne', 'Berlin', 'Munich', 'Hambourg', 'Cologne', 'Francfort', 'Dresde'],
  US: ['États-Unis', 'New York', 'Los Angeles', 'Chicago', 'San Francisco', 'Miami', 'Boston'],
  GB: ['Royaume-Uni', 'Londres', 'Édimbourg', 'Manchester', 'Bristol', 'Liverpool', 'Cardiff'],
  ES: ['Espagne', 'Barcelone', 'Madrid', 'Séville', 'Valence', 'Bilbao', 'Grenade'],
  IT: ['Italie', 'Rome', 'Florence', 'Venise', 'Milan', 'Naples', 'Bologne'],
  PT: ['Portugal', 'Lisbonne', 'Porto', 'Coimbra', 'Faro', 'Braga', 'Sintra'],
  BE: ['Belgique', 'Bruxelles', 'Bruges', 'Gand', 'Anvers', 'Liège', 'Namur'],
  CH: ['Suisse', 'Genève', 'Zurich', 'Lausanne', 'Berne', 'Lucerne', 'Bâle'],
  AT: ['Autriche', 'Vienne', 'Salzbourg', 'Innsbruck', 'Graz', 'Linz', 'Hallstatt'],
  NL: ['Pays-Bas', 'Amsterdam', 'Rotterdam', 'Utrecht', 'La Haye', 'Delft', 'Maastricht'],
  IE: ['Irlande', 'Dublin', 'Galway', 'Cork', 'Limerick', 'Kilkenny', 'Killarney'],
  CA: ['Canada', 'Montréal', 'Québec', 'Toronto', 'Vancouver', 'Ottawa', 'Calgary'],
  AU: ['Australie', 'Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adélaïde', 'Hobart'],
  NZ: ['Nouvelle-Zélande', 'Auckland', 'Wellington', 'Queenstown', 'Christchurch', 'Dunedin', 'Rotorua'],
  JP: ['Japon', 'Kyoto', 'Tokyo', 'Osaka', 'Nara', 'Hiroshima', 'Sapporo'],
  MA: ['Maroc', 'Marrakech', 'Casablanca', 'Rabat', 'Fès', 'Tanger', 'Essaouira'],
  TN: ['Tunisie', 'Tunis', 'Sousse', 'Sfax', 'Kairouan', 'Bizerte', 'Hammamet'],
  DZ: ['Algérie', 'Alger', 'Oran', 'Constantine', 'Annaba', 'Tlemcen', 'Béjaïa'],
  BR: ['Brésil', 'Rio de Janeiro', 'São Paulo', 'Salvador', 'Brasília', 'Recife', 'Florianópolis'],
  MX: ['Mexique', 'Mexico', 'Guadalajara', 'Oaxaca', 'Mérida', 'Puebla', 'Guanajuato'],
  IN: ['Inde', 'Mumbai', 'New Delhi', 'Jaipur', 'Agra', 'Udaipur', 'Varanasi'],
  KR: ['Corée du Sud', 'Séoul', 'Busan', 'Incheon', 'Gyeongju', 'Daegu', 'Jeonju'],
  SE: ['Suède', 'Stockholm', 'Göteborg', 'Malmö', 'Uppsala', 'Lund', 'Visby'],
  NO: ['Norvège', 'Oslo', 'Bergen', 'Tromsø', 'Trondheim', 'Stavanger', 'Ålesund'],
  DK: ['Danemark', 'Copenhague', 'Aarhus', 'Odense', 'Aalborg', 'Roskilde', 'Ribe'],
  PL: ['Pologne', 'Varsovie', 'Cracovie', 'Gdańsk', 'Wrocław', 'Poznań', 'Toruń'],
  GR: ['Grèce', 'Athènes', 'Thessalonique', 'La Canée', 'Nauplie', 'Rhodes', 'Corfou'],
  TR: ['Turquie', 'Istanbul', 'Ankara', 'Izmir', 'Antalya', 'Bursa', 'Konya'],
  AE: ['Émirats arabes unis', 'Dubaï', 'Abou Dabi', 'Charjah', 'Al-Aïn', 'Ajman', 'Fujaïrah'],
  ID: ['Indonésie', 'Bali', 'Jakarta', 'Yogyakarta', 'Ubud', 'Lombok', 'Bandung'],
};
const DETECTION_KEY = 'muraletta:ip-country:v2';
const rootPath = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
const originals = new WeakMap();
let activeCountry = 'FR';
let detectionPromise;
let countryDetected = false;
const LOCAL_CITIES = {
  DE: ['Berlin','München','Hamburg','Köln','Frankfurt','Dresden'], GB:['London','Edinburgh','Manchester','Bristol','Liverpool','Cardiff'],
  ES:['Barcelona','Madrid','Sevilla','Valencia','Bilbao','Granada'], IT:['Roma','Firenze','Venezia','Milano','Napoli','Bologna'],
  PT:['Lisboa','Porto','Coimbra','Faro','Braga','Sintra'], BE:['Brussel','Brugge','Gent','Antwerpen','Luik','Namen'],
  CH:['Genf','Zürich','Lausanne','Bern','Luzern','Basel'], AT:['Wien','Salzburg','Innsbruck','Graz','Linz','Hallstatt'],
  NL:['Amsterdam','Rotterdam','Utrecht','Den Haag','Delft','Maastricht'], AU:['Sydney','Melbourne','Brisbane','Perth','Adelaide','Hobart'],
  JP:['京都','東京','大阪','奈良','広島','札幌'], KR:['서울','부산','인천','경주','대구','전주'],
  DK:['København','Aarhus','Odense','Aalborg','Roskilde','Ribe'], PL:['Warszawa','Kraków','Gdańsk','Wrocław','Poznań','Toruń'],
  GR:['Αθήνα','Θεσσαλονίκη','Χανιά','Ναύπλιο','Ρόδος','Κέρκυρα'], MX:['Ciudad de México','Guadalajara','Oaxaca','Mérida','Puebla','Guanajuato'],
  TR:['İstanbul','Ankara','İzmir','Antalya','Bursa','Konya'], AE:['Dubai','Abu Dhabi','Sharjah','Al Ain','Ajman','Fujairah'],
};
const ARABIC_CITIES = {
  MA:['مراكش','الدار البيضاء','الرباط','فاس','طنجة','الصويرة'],
  DZ:['الجزائر','وهران','قسنطينة','عنابة','تلمسان','بجاية'],
  AE:['دبي','أبو ظبي','الشارقة','العين','عجمان','الفجيرة'],
};

function storageGet(type, key) {
  try { return window[type].getItem(key); } catch { return null; }
}
function storageSet(type, key, value) {
  try { window[type].setItem(key, value); } catch { /* Storage may be disabled. */ }
}
function normalizeCountry(value) {
  const code = String(value || '').toUpperCase();
  if (!/^[A-Z]{2}$/.test(code) || ['ZZ', 'XX'].includes(code)) return null;
  if (COUNTRY_CITIES[code]) return code;
  try { return new Intl.DisplayNames(['fr'], { type: 'region', fallback: 'none' }).of(code) ? code : null; }
  catch { return null; }
}
function details(code) {
  const locale = document.documentElement.lang || 'fr';
  let name = code;
  try { name = new Intl.DisplayNames([locale], { type: 'region' }).of(code); } catch { /* Retain country code. */ }
  const cities = COUNTRY_CITIES[code]?.slice(1) || [name];
  if(locale==='ar'&&ARABIC_CITIES[code])return {name,cities:ARABIC_CITIES[code]};
  if(code==='CH'&&locale==='it')return {name,cities:['Ginevra','Zurigo','Losanna','Berna','Lucerna','Basilea']};
  return { name, cities: locale.startsWith('fr') ? cities : LOCAL_CITIES[code] || cities };
}
function studioUrl(place, country) {
  const query = place === country ? place : `${place}, ${country}`;
  return `${rootPath}pages/creer-mon-affiche-studio?q=${encodeURIComponent(query)}`;
}
function element(tag, className, text) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text !== undefined) node.textContent = text;
  return node;
}
function original(node) {
  if (!originals.has(node)) originals.set(node, [...node.childNodes].map(child => child.cloneNode(true)));
  return originals.get(node).map(child => child.cloneNode(true));
}
function countryArt(city, country) {
  const art = element('span', 'muraletta-country-art');
  const longestWord = Math.max(...city.split(/[\s-]/).map(word => word.length));
  art.style.setProperty('--city-size', `${Math.min(32, 290 / Math.max(9, longestWord))}px`);
  art.append(element('span', 'muraletta-country-art__label', t('À imaginer dans le Studio')),
    element('span', 'muraletta-country-art__city', city),
    element('span', 'muraletta-country-art__line'),
    element('span', 'muraletta-country-art__country', country));
  art.querySelector('.muraletta-country-art__line').setAttribute('aria-hidden', 'true');
  return art;
}
function productCard(product) {
  const article = element('article', 'muraletta-product-rail__card');
  article.setAttribute('role', 'listitem');
  const link = element('a', 'muraletta-product-rail__card-link');
  link.href = product.url;
  const wrap = element('span', 'muraletta-product-rail__image-wrap');
  if (product.image) {
    const image = element('img', 'muraletta-product-rail__image');
    image.src = product.image;
    image.alt = product.title;
    image.loading = 'lazy';
    image.width = 700; image.height = 1050;
    wrap.append(image);
  }
  if (!product.available) wrap.append(element('span', 'muraletta-product-rail__badge', t('Épuisé')));
  const [title, ...subtitle] = product.title.split(' – ');
  link.append(wrap, element('span', 'muraletta-product-rail__product-title', title));
  if (subtitle.length) link.append(element('span', 'muraletta-product-rail__subtitle', subtitle.join(' – ')));
  link.append(element('span', 'muraletta-product-rail__price', `${product.varies ? t('Dès') + ' ' : ''}${product.price}`));
  const personalize = element('a', 'muraletta-card-personalize', t('Personnaliser cette affiche'));
  personalize.href = `${product.url}?personnaliser=1`;
  article.append(link, personalize);
  return article;
}
function inspirationCard(city, country) {
  const article = element('article', 'muraletta-product-rail__card');
  article.setAttribute('role', 'listitem');
  const link = element('a', 'muraletta-product-rail__card-link');
  link.href = studioUrl(city, country);
  link.append(countryArt(city, country), element('span', 'muraletta-country-card__cta', t('Créer une affiche de {city}', { city })),
    element('span', 'muraletta-country-card__note', t('Inspiration • Studio en découverte')));
  article.append(link);
  return article;
}
function countryCollections() {
  try { return JSON.parse(document.querySelector('[data-country-collections]')?.textContent || '{}'); }
  catch { return {}; }
}
function renderCountry(code) {
  activeCountry = code;
  const { name, cities } = details(code);
  const collection = countryCollections()[code];
  const products = collection?.products || [];
  const hasProducts = products.length > 0;
  document.documentElement.dataset.inspirationCountry = code;
  if (code !== 'FR') document.querySelectorAll('[data-country-faq]').forEach(question => { question.textContent = t('Avez-vous toutes les villes de ce pays ?'); });

  document.querySelectorAll('[data-country-rail]').forEach(rail => {
    const header = rail.querySelector('.muraletta-product-rail__header');
    const scroller = rail.querySelector('.muraletta-product-rail__scroller');
    if (!header || !scroller) return;
    const savedHeader = original(header);
    const savedCards = original(scroller);
    const notice = rail.querySelector('[data-country-notice]');
    if (code === 'FR') {
      header.replaceChildren(...savedHeader);
      scroller.replaceChildren(...savedCards);
      if (notice) notice.hidden = true;
    } else {
      const heading = t('Affiches — {country}', {country:name});
      header.querySelector('h2').textContent = heading;
      const eyebrow = header.querySelector('.muraletta-product-rail__eyebrow');
      if (eyebrow) eyebrow.textContent = t('Des lieux qui vous ressemblent');
      const allLink = header.querySelector('a');
      if (allLink) {
        allLink.href = hasProducts ? collection.url : studioUrl(name, name);
        allLink.textContent = hasProducts ? t('Tout découvrir →') : t('Explorer le Studio →');
      }
      scroller.replaceChildren(...(hasProducts ? products.map(productCard) : cities.slice(0, 3).map(city => inspirationCard(city, name))));
      if (notice) {
        notice.hidden = hasProducts;
        notice.textContent = t('Ces villes ne sont pas encore au catalogue. Imaginez votre affiche dans le Studio : la création est en découverte, la commande personnalisée n’est pas encore ouverte.');
      }
    }
    scroller.setAttribute('aria-label', rail.querySelector('h2').textContent);
    scroller.scrollLeft = 0;
    rail.querySelectorAll('[data-rail-direction]').forEach(button => button.setAttribute('aria-label', t('Faire défiler {title} vers la {direction}', {title:rail.querySelector('h2').textContent, direction:Number(button.dataset.railDirection) < 0 ? t('gauche') : t('droite')})));
    requestAnimationFrame(() => rail.dispatchEvent(new Event('muraletta:country-updated')));
  });

  document.querySelectorAll('[data-country-tile]').forEach(tile => {
    // Lead with the visitor's country rather than the generic world collection.
    if (tile.parentElement.firstElementChild !== tile) tile.parentElement.prepend(tile);
    const saved = original(tile);
    if (code === 'FR') { tile.replaceChildren(...saved); return; }
    const link = element('a', 'muraletta-categories__tile');
    link.href = hasProducts ? collection.url : studioUrl(name, name);
    if (hasProducts && products[0].image) {
      const wrap = element('span', 'muraletta-categories__image-wrap');
      const image = element('img', 'muraletta-categories__image');
      image.src = products[0].image; image.alt = products[0].title; image.loading = 'lazy';
      image.width = 700; image.height = 1050;
      wrap.append(image); link.append(wrap);
    } else link.append(countryArt(cities[0], name));
    const meta = element('span', 'muraletta-categories__meta');
    meta.append(element('span', 'muraletta-categories__item-title', t('Villes — {country}', {country:name})),
      element('span', 'muraletta-categories__subtitle', hasProducts ? t('La sélection locale ›') : t('À créer dans le Studio ›')));
    link.append(meta); tile.replaceChildren(link);
  });

  document.querySelectorAll('.muraletta-footer__regions').forEach(directory => {
    const saved = original(directory);
    if (code === 'FR') {
      directory.replaceChildren(...saved);
      directory.setAttribute('aria-label', t('Créer une affiche par département'));
    } else {
      directory.setAttribute('aria-label', t('Voir les villes — {country}', {country:name}));
      directory.replaceChildren(element('h2', '', t('Vos villes — {country}', {country:name})),
        element('p', 'muraletta-footer__directory-note', t('Imaginez ces lieux dans le Studio. La commande personnalisée n’est pas encore ouverte.')),
        ...cities.map(city => { const link = element('a', '', city); link.href = studioUrl(city, name); return link; }));
    }
  });
  document.querySelectorAll('.muraletta-hero__search-input').forEach(input => {
    input.placeholder = `${cities.slice(0, 3).join(', ')}…`;
  });
  renderMenus(code, name, cities, hasProducts ? collection.url : studioUrl(name, name));
  document.dispatchEvent(new CustomEvent('muraletta:country-detected', { detail: { country: code } }));
}
function renderMenus(code, name, cities, destination) {
  if (code === 'FR') return;
  const products = countryCollections()[code]?.products || [];
  document.querySelectorAll('[data-local-country-menu]').forEach(menu => {
    if (menu.dataset.countryApplied === code) return;
    menu.dataset.countryApplied = code;
    const mobile = !!menu.closest('header-drawer');
    const label = menu.querySelector(mobile ? '.menu-drawer__menu-item--mainlist .menu-drawer__menu-item-text' : '.menu-list__link-title');
    if (label) label.textContent = t('Affiches — {country}', {country:name});
    const parentLink = menu.querySelector(mobile ? 'a.menu-drawer__menu-item--mainlist' : 'a.menu-list__link');
    if (parentLink) parentLink.href = destination;
    const submenuLabel = menu.querySelector('.menu-list__disclosure .visually-hidden');
    if (submenuLabel) submenuLabel.textContent = t('Voir les villes — {country}', {country:name});
    const list = menu.querySelector(mobile ? '.menu-drawer__menu--childlist' : '.mega-menu__list');
    const entries = products.length
      ? products.map(product => ({ title: product.title.split(' – ')[0], url: product.url }))
      : cities.map(city => ({ title: city, url: studioUrl(city, name) }));
    if (list) list.replaceChildren(...entries.map(entry => {
      const item = element('li', mobile ? 'menu-drawer__list-item' : 'mega-menu__column mega-menu__column--span-1');
      const link = element('a', mobile ? 'menu-drawer__menu-item menu-drawer__menu-item--child' : 'mega-menu__link', entry.title);
      link.href = entry.url;
      item.append(link); return item;
    }));
  });
  document.querySelectorAll('.muraletta-footer a[href$="/collections/affiches-de-france"]').forEach(link => {
    link.href = destination; link.textContent = t('Affiches — {country}', {country:name});
  });
}
async function detectCountry() {
  if (detectionPromise) return detectionPromise;
  detectionPromise = (async () => {
    const fallback = normalizeCountry(document.documentElement.dataset.countryDefault) || 'FR';
    try {
      const cached = JSON.parse(storageGet('sessionStorage', DETECTION_KEY) || 'null');
      if (cached && Date.now() - cached.at >= 0 && Date.now() - cached.at < 300000 && normalizeCountry(cached.country)) {
        countryDetected = true;
        return normalizeCountry(cached.country);
      }
    } catch { /* Invalid/disabled cache: use live detection. */ }
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3000);
    try {
      const response = await fetch(`${rootPath}browsing_context_suggestions.json?country[enabled]=true`, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Country detection unavailable');
      const country = normalizeCountry((await response.json()).detected_values?.country?.handle);
      if (!country) throw new Error('No detected country');
      countryDetected = true;
      storageSet('sessionStorage', DETECTION_KEY, JSON.stringify({ country, at: Date.now() }));
      return country;
    } catch { return fallback; }
    finally { clearTimeout(timeout); }
  })();
  return detectionPromise;
}
async function start() {
  // Old selections and ?inspiration= links no longer override the visitor's IP country.
  try { localStorage.removeItem('muraletta:inspiration-country:v1'); } catch { /* Storage may be disabled. */ }
  const country = await detectCountry();
  if (countryDetected && redirectLanguage(country)) return;
  renderCountry(country);
  document.addEventListener('shopify:section:load', () => renderCountry(activeCountry));
  // Horizon may hydrate the menu after the initial render; keep that menu localized too.
  const header = document.getElementById('header-group');
  if (header) new MutationObserver(() => {
    const { name, cities } = details(activeCountry);
    const collection = countryCollections()[activeCountry];
    renderMenus(activeCountry, name, cities, collection?.products?.length ? collection.url : studioUrl(name, name));
  }).observe(header, { childList: true, subtree: true });
}
function redirectLanguage(country) {
  let config;
  try { config = JSON.parse(document.querySelector('[data-muraletta-localization]').textContent); } catch { return false; }
  if (config.designMode || window.Shopify?.designMode) return false;
  const desired = languageForCountry(country, navigator.languages || [navigator.language]);
  // Never pretend an unfinished/unpublished translation is available.
  const target = config.languages.find(locale => locale.toLowerCase() === desired.toLowerCase());
  if (!target || target.toLowerCase() === config.locale.toLowerCase()) {
    const url = new URL(location.href);
    if (url.searchParams.has('_ml')) { url.searchParams.delete('_ml'); history.replaceState(history.state, '', url); }
    return false;
  }
  const url = new URL(location.href);
  const guard = `${country}:${target}`;
  if (url.searchParams.get('_ml') === guard) return false;
  const currentPrefix = rootPath.replace(/\/$/,'');
  let path = url.pathname;
  if (currentPrefix && (path.toLowerCase() === currentPrefix.toLowerCase() || path.toLowerCase().startsWith(currentPrefix.toLowerCase() + '/'))) path = path.slice(currentPrefix.length) || '/';
  const nativeRoot = config.roots?.[target];
  // Guard against Shopify returning the current root for every available language.
  const nativePrefix = typeof nativeRoot === 'string' && /^\/(?!\/)/.test(nativeRoot) ? nativeRoot.replace(/\/+$/,'') : null;
  const targetRoot = nativePrefix !== null && nativePrefix.toLowerCase() !== currentPrefix.toLowerCase()
    ? nativePrefix : (target === 'fr' ? '' : target === 'pt-BR' ? '/pt' : `/${target.toLowerCase()}`);
  url.pathname = targetRoot + path;
  url.searchParams.set('_ml', guard);
  location.replace(url.href);
  return true;
}
start();
